(function ($) {
	// Set scrollbar width
	function setScrollbarWidth() {
		// Creating invisible container
		const outer = document.createElement('div');
		outer.style.visibility = 'hidden';
		outer.style.overflow = 'scroll'; // forcing scrollbar to appear
		outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
		document.body.appendChild(outer);

		// Creating inner element and placing it in the container
		const inner = document.createElement('div');
		outer.appendChild(inner);

		// Calculating difference between container's full width and the child width
		const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

		// Removing temporary elements from the DOM
		outer.parentNode.removeChild(outer);

		$(':root').css('--scrollbar-width', `${scrollbarWidth}px`, '0px');
	}
	setScrollbarWidth();

	// Set unit variables
	const unitVariables = {
		'container': $('main > .container-xxl')
	};

	function setUnitVariables(elements) {
		$(':root').css('--container-width', `${elements.container.innerWidth() ?? 0}px`, '0px');
	}
	setUnitVariables(unitVariables);

	$(window).resize(function () {
		setUnitVariables(unitVariables);
	});

	// Set header height
	window.addEventListener('scroll', () => {
		document.body.classList.toggle('scrolled', window.scrollY > 16);
	});

	// Disable onclick event in sub page menu item if has class "active".
	$('.page-sub-menu a').click(function (event) {
		if ($(this).hasClass('active')) {
			event.preventDefault();
		}
	});

	// GB tables.
	$('.wp-block-table > table:not(.betable__table)').wrap('<div class="table-wrapper"></div>');

	// Block link GB block add stretched link class
	document.querySelectorAll('.wp-block-block-link').forEach(function (item) {
		const link = item.querySelector('a');
		if (link) {
			link.classList.add('stretched-link');
		}
	});

	// Leagues list
	document.querySelectorAll('.leagues-list>.wp-block-column').forEach(function (item) {
		const link = item.querySelector('a');
		if (link) {
			link.classList.add('stretched-link');
		}
	});

	// Add attribute to the search button (on desktop).
	const searchButton = document.querySelector('.search-menu-item>a');
	searchButton.setAttribute('arial-label', 'Search');
	searchButton.setAttribute('title', 'Search');
})(jQuery);